const UrlHelperPlugin = {
    baseUrl: null,
    apiBaseUrl: null,
    imagesBaseUrl: null,
    fileDownloadBaseUrl: null,

    getPageUrl: function (relativePagePath, additionalPathSegments = []) {
        var url = this.baseUrl;
        if (!url.endsWith('/')) url += '/';
        url += relativePagePath;
        if ((additionalPathSegments != null) && (additionalPathSegments.length > 0)) {
            for (var index = 0; index < additionalPathSegments.length; ++index) {
                if (additionalPathSegments[index] == null) continue;
                url += '/';
                url += additionalPathSegments[index].toString();
            }
        }
        return url;
    },
    getApiUrl: function (controller, methodOrPath = null, additionalPathSegments = []) {
        var url = this.apiBaseUrl;
        if (!url.endsWith('/')) url += '/';
        url += controller;
        if (methodOrPath != null) {
            url += '/';
            url += methodOrPath;
        }
        if ((additionalPathSegments != null) && (additionalPathSegments.length > 0)) {
            for (var index = 0; index < additionalPathSegments.length; ++index) {
                if (additionalPathSegments[index] == null) continue;
                url += '/';
                url += additionalPathSegments[index].toString();
            }
        }
        return url;
    },
    getImageUrl: function (relativeImagePath) {
        var url = this.imagesBaseUrl;
        if (!url.endsWith('/')) url += '/';
        url += relativeImagePath;
        return url;
    },
    getFileDownloadUrl: function (fileId) {
        var url = this.fileDownloadBaseUrl;
        if (!url.endsWith('/')) url += '/';
        url += fileId;
        return url;
    },

    install(Vue, options) {
        this.baseUrl = options.baseUrl;
        this.apiBaseUrl = options.apiBaseUrl;
        this.imagesBaseUrl = options.imagesBaseUrl;
        this.fileDownloadBaseUrl = options.fileDownloadBaseUrl;
        Vue.prototype.$urlHelper = UrlHelperPlugin;
    }
};

export default UrlHelperPlugin;